/* eslint-disable no-unused-vars */
'use client'

import * as React from 'react'

export enum TextDirection {
  RightToLeft = 'RTL',
  LeftToRight = 'LTR'
}

export interface ThemeContextProps {
  currentTheme?: string
  direction?: TextDirection
}


export const ThemeContext = React.createContext<ThemeContextProps>({})
